module.exports = __webpack_public_path__ + "static/media/logo_swobbee.f84ac049.svg";